import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Seo from "@/components/feature/Seo";
import { brand } from "@/mocks/siteData";
import { useHashScroll } from "@/hooks/useHashScroll";
import ContactHero from "./components/ContactHero";
import ContactChannels from "./components/ContactChannels";
import ContactFormSection from "./components/ContactFormSection";
import ContactFaq from "./components/ContactFaq";

export default function Contact() {
  useHashScroll();

  return (
    <div className="min-h-screen bg-background-50 overflow-x-hidden">
      <Seo
        title={`Contact ${brand.name} | Farm & Village Experiences`}
        description="Get in touch with the Rythugaru team — ask about farm experiences, plan a visit, partner with us or find us in Konaseema, Andhra Pradesh."
        path="/contact"
        keywords="contact Rythugaru, agri tourism contact India, plan a farm visit Konaseema, farm partner enquiry"
        image="https://readdy.ai/api/search-image?query=Peaceful%20rural%20Indian%20village%20with%20green%20fields%20and%20a%20winding%20canal%20at%20sunrise%2C%20warm%20golden%20light%2C%20fresh%20green%20tones%2C%20cinematic%20landscape%2C%20ultra%20detailed&width=1920&height=1080&seq=contact-page-cover&orientation=landscape"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "ContactPage",
          name: `Contact ${brand.fullName}`,
          inLanguage: "en",
        }}
      />
      <Navbar />
      <main>
        <ContactHero />
        <ContactChannels />
        <ContactFormSection />
        <ContactFaq />
      </main>
      <Footer />
    </div>
  );
}